import React, {Component, Fragment} from 'react';
import {cloneDeep} from "lodash";
import {Col, Modal, Row, Input, Form, Upload, Button, Select, message, Table, Tooltip} from "antd";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import {ProjectOutlined, InboxOutlined, DeploymentUnitOutlined, SearchOutlined} from '@ant-design/icons';
import API from "../scripts/api";
import PaginationInfo from "../components/PaginationInfo";
import moment from "moment-jalaali";
import {Constants} from "../scripts/settings";

class OutBarcodes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            title: '',
            Filter: '',
            FilterPacking: '',
            id: '',
            barcodesCount: 0,

            deletedBarcodes:[],
            barcodes:[],
            data:[],
            packBarcodeInfo: [],
            pagination: {
                                total: 0,
                                current: 1,
                                pageSize: Constants.pageSize,
                                size: "small",
                              },
        };

        this.formRef = React.createRef();
        this.deleteBarcode = React.createRef();
    }


    handleSubmit = () => {
        let {publishRateArr} = this.state

    };

    handleWillUnmount = () => {
        // this.formRef.current.resetFields();
    };

    handleDidMount = (data = {}) => {
        const cloneData = cloneDeep(data);
        console.log(!!cloneData.id);
        this.setState({editMode: !!cloneData.id, id: cloneData.id});
        if(!!cloneData.id){
            this.setState({barcodes: cloneData.range})
            this.productOutBarcodes(cloneData.id, {})
        }
    }

    productOutBarcodes = (id, params = {}) => {
        const { barcode, package_count } = this.state;
        if(barcode) params.barcode = barcode
        if(package_count) params.package_count = package_count
        this.setState({ loading: true });
        API.printBarcode.productOutBarcodes(id, params)
            .then((result) => {
                if (result.data) {
                    this.setState({
                        loading: false,
                        data: result.data.data,
                        packBarcodeInfo: result.packBarcodeInfo,
                        pagination: {
                            ...this.state.pagination,
                            ...{
                              current: result.data.current_page,
                              pageSize: result.data.per_page,
                              total: result.data.total,
                            },
                          },
                          barcodesCount: result.data.total,

                    });
                } else {
                    this.setState({ loading: false });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleFilter = (value, obj) => {
        const state = {};
        state[obj] = value;
    
        this.setState(state);
    
        setTimeout(() => {
          this.productOutBarcodes(this.state.id, {});
        }, 0);
      };

    handleFilterPacking = (value) => {
        this.setState({ Filter: "" });
        this.setState({ FilterPacking: value });
    }

    handleTableChange = async (pagination) => {
        
        await this.productOutBarcodes(this.state.id, {page: pagination.current});
      };
    render() {
        const {onCancel, submitting, visible} = this.props;
        const { loading, data, Filter, FilterPacking, pagination, barcodesCount, packBarcodeInfo} = this.state;


      
        const columns = [
            {
                title: Resources.barcode,
                dataIndex: "barcode",
                width: "30px",
            },
            {
                title: Resources.registrar,
                dataIndex: "user",
                width: "30px",
                render: (val) => val?.name+ " "+ val?.family,
            },
            {
                title: Resources.buyer,
                dataIndex: "cart",
                width: "30px",
                render: (val) => val?.user?.name+ " "+ val?.user?.family,
            },
            {
                title: Resources.buyer_mobile,
                dataIndex: "cart",
                width: "30px",
                render: (val) => val?.user?.phone,
            },
            {
                title: Resources.packing,
                dataIndex: "print_barcode",
                width: "30px",
                render: (val) => val?.package_count,
            },

            {
                title: Resources.row,
                dataIndex: "row",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.identifier,
                dataIndex: "identifier",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.shelf,
                dataIndex: "shelf",
                width: "30px",
                render: (val) => val?.title,
            },
            {
                title: Resources.dateAndTime,
                dataIndex: "created_at",
                width: "30px",
                render: (val) => moment(val).format(Constants.jDateTimeFormat),
            },
            {
                title: Resources.type,
                dataIndex: "is_scan",
                width: "30px",
                render: (val) => (val == "1") ? <span style={{color:"blue"}}  >{Resources.scanned}</span>:  <span style={{color:"red"}}  >{Resources.deleted}</span>,
            },
           
           
        ];
        return (
            <Fragment>
                <Modal
                    title={ Resources.outBarcodesList}
                    visible={visible}
                    onOk={this.handleSubmit}
                    onCancel={onCancel}
                    okText={Resources.confirm}
                    cancelText={Resources.cancel}
                    okButtonProps={{loading: submitting}}
                    cancelButtonProps={{disabled: submitting}}
                    footer={null}
                    width={1000}
                >
                    <div className="ant-content">
                        <Row gutter={24}>
                            <Col xs={24} md={6}>
                                <Tooltip title={Resources.searchHintUser}>
                                    <Input
                                        type="text"
                                        prefix={<SearchOutlined />}
                                        placeholder={Resources.barcode}
                                        onChange={({ target: { value } }) =>
                                            this.handleFilter(value, "barcode")
                                        }
                                        allowClear
                                    />
                                </Tooltip>
                            </Col>

                            <Col xs={24} md={6}>
                                <Tooltip title={Resources.searchHintUser}>
                                    <Input
                                        type="text"
                                        prefix={<SearchOutlined />}
                                        placeholder={Resources.packing}
                                        onChange={({ target: { value } }) =>
                                            this.handleFilter(value, "package_count")
                                        }
                                        allowClear
                                    />
                                </Tooltip>
                            </Col>

                            <Col xs={24} md={12}>
                                <div style={{ float:"left"}}>
                                    <span style={{color:"green"}}>{Resources.barcodesCount}</span>:
                                    <span style={{margin:"5px"}}>{barcodesCount}</span>
                                </div>

                            </Col>
                        </Row>
                    </div>
                    <hr />
                    <Row style={{marginTop: "10px"}} gutter={24}>
                        {
                            packBarcodeInfo && packBarcodeInfo.length &&
                            packBarcodeInfo.map((item) => {
                                
                                return (<Col xs={24} md={6}>
                                    <span>{`${item.delete_barcode_count} ${Resources.category}  ${item.package_count}  ${Resources.tay} `} </span> :
                                    <span style={{marginRight: "10px", color:"red"}}>{parseInt(item.package_count) * parseInt(item.delete_barcode_count)}</span>
                                </Col>)
                    
                                })
                            }
                        </Row>
                    
                                        <hr />
                    <div className="ant-content">
                        <Table
                            columns={columns}
                            dataSource={data}
                            loading={loading}
                            onChange={this.handleTableChange}
                            pagination={pagination}

                            size="small"
                            rowKey="id"
                            // scroll={{ x: 936 }}
                        />

                    </div>
                </Modal>
            </Fragment>
        );
    }
}

export default OutBarcodes;
